import { useEffect, useState } from "react";
import Navbar from "../../components/layout/navbar";
import useRequest from "../../components/hooks/use-request";
import Button from "../../components/button";
import { Plus } from "lucide-react";
import StatisticsCard from "./statistics-card";
import Supplier from "./supplier";
import AddSupplierDialog from "../../components/suppliers/add-supplier-dialog";
import { I_ProductData } from "../inventory/types";

interface ProfileData {
  username: string;
  email: string;
  phone: string;
  address: string;
  lastLogin: string;
}

interface MetricsData {
  totalActiveSupplier: number;
  totalInactiveSupplier: number;
  totalSupplier: number;
  totalSupplierPendingApproval: number;
}

const Suppliers = () => {
  const [profile, setProfile] = useState<ProfileData | null>(null);
  const [customerModal, setCustomerModal] = useState(false);
  const [metrics, setMetrics] = useState<MetricsData | null>(null);
    const [product, setProduct] = useState<I_ProductData[]>([]);
    const [suppliers, setSuppliers] = useState<[]>([]);


  const userToken = localStorage.getItem("token");
  const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
    Authorization: `Bearer ${userToken}`,
  });

  const { makeRequest: getMetrics } = useRequest("/suppliers/metric", "GET", {
    Authorization: `Bearer ${userToken}`,
  });

    const { makeRequest: getSuppliers } = useRequest("/suppliers", "GET", {
      Authorization: `Bearer ${userToken}`,
    });

    const { makeRequest: getProducts } = useRequest("/inventory", "GET", {
      Authorization: `Bearer ${userToken}`,
    });

  useEffect(() => {
    const fetchProfile = async () => {
      const [response] = await getProfile();
      if (response.status) {
        setProfile(response.data?.user);
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchMetrics = async () => {
      const [response] = await getMetrics();
      if (response.status) {
        setMetrics(response.data);
      }
    };
    fetchMetrics();
  }, []);

    useEffect(() => {
      const fetchSuppliers = async () => {
        const [response] = await getSuppliers();
        if (response.status) {
          setSuppliers(response.data?.suppliers?.docs);
        }
      };
      fetchSuppliers();
    }, []);

      useEffect(() => {
        const fetchProducts = async () => {
          const [response] = await getProducts();
          if (response.status) {
            setProduct(response.data?.inventory?.docs);
          }
        };
        fetchProducts();
      }, []);

  function closeSupplierModal() {
    setCustomerModal(false);
  }

  function openSupplierModal() {
    setCustomerModal(true);
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar profile={profile as ProfileData} />
      <main className="flex-1 container mx-auto py-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6">
          <div className="mb-4 sm:mb-0">
            <h1 className="text-[30px] font-extrabold text-black">
              Suppliers Management
            </h1>
            <p className="text-[#676767] text-[18px] font-normal">
              Manage your suppliers and vendor relationships
            </p>
          </div>
          <div className="flex gap-2">
            <button className="rounded-full border px-4 py-1">Export</button>

            <Button
              size="lg"
              variant="primary"
              type="button"
              className="font-normal md:mt-0 mt-6"
              onClick={openSupplierModal}
            >
              <Plus /> Create Supplier
            </Button>
          </div>
        </div>
        {metrics && <StatisticsCard metrics={metrics} />}
        <Supplier data={suppliers} />
      </main>

      <AddSupplierDialog
      
        isVisible={customerModal}
        onClose={closeSupplierModal}
        product={product}
      />
    </div>
  );
};

export default Suppliers;
